/*@ngInject*/
const SelectFilterController = function ($scope, $q, $element, $filter, $timeout, advancedFilterModel,
                                         coreConstant, coreMediator, formatUtil, localization, dataSetUtil) {

    this.appendToBody = true;
    this.filterDropdownIdentifier = 'filterDropdown';
    let itemLongList = {warning: true, disabled: true, 'name': null},
        timeoutList = [];

    this.$onInit = function () {
        let criterionTemplate = this.criterionTemplate,
            dataSetName = criterionTemplate.dataSetName,
            submissionUri = !_.isNil(this.submissionId) ? 'com.firstbest.underwriting.submission.Submission:' + this.submissionId : null,
            variableName = criterionTemplate.variableName,
            dataSetParams = dataSetUtil.getDataSetParamsByName(dataSetName, variableName, submissionUri);

        this.tooltip = {
            delay: 750
        };

        localization.getTranslationsByKeys([this.translationsKey, 'advancedFilter']).then((translations) => {
            this.placeholder = _.get(translations.selectFilter, this.criterionTemplate.variableName + '.placeholder') || translations.placeholder;
            this.tooltip.message = translations.removeButtonTooltip;
        });

        localization.getTranslationByKey('formsViewer.controls.dropdown.longListWarning').then(function (text) {
            itemLongList.name = text;
        });

        this.itemsList = [];
        this.isOpen = true;

        return dataSetUtil.getDataItems(dataSetParams).then(function(items){
            this.setItemsList(items);
       //     return items;
        }.bind(this));
    };



    this.formatAsSelector = function (nameString) {
        return nameString ? formatUtil.formatAsSelector(nameString) : '';
    };

    this.setItemsList = function (itemsList) {
        this.itemsList = itemsList;
        this.filterItems();
        this.updateDropdownSelectedValue();
    };

    this.filterItems = function (searchText) {
        let filteredItemsList = [];

        if (!_.isEmpty(searchText)) {
            filteredItemsList = _.filter(this.itemsList, function (item) {
                return _.includes(item.name.toLowerCase(), searchText.toLowerCase());
            });
        } else if (_.isArray(this.itemsList)) {
            filteredItemsList = this.itemsList;
        }

        if (filteredItemsList.length > 150) {
            this.showLongListWarning(filteredItemsList.length);
        } else {
            this.filteredItemsList = filteredItemsList;
        }
    };

    this.showLongListWarning = function (listLength) {
        let item = _.clone(itemLongList);
        item.name = _.replace(item.name, '{0}', $filter('number')(listLength));

        this.filteredItemsList = [item];
        this.isSpecialMessageDisplayed = true;
    };

    this.updateDropdownSelectedValue = function () {
        let criterionValue = this.criterionTemplate.value,
            selectedValue = null;
        if (!_.isNil(criterionValue)) {

            selectedValue = _.find(this.itemsList, {value: criterionValue});

            if (!_.isNil(selectedValue)) {
                this.dropdownSelectedValue = selectedValue;
            } else {
                this.dropdownSelectedValue = _.intersectionWith(this.itemsList, _.split(criterionValue, '::'),
                    function (dataItem, criterionItem) {
                        if (dataItem.value === criterionItem) {
                            dataItem.selected = true;
                            return true;
                        } else {
                            return false;
                        }
                    }
                );
            }
        } else {
            this.dropdownSelectedValue = null;
        }

        $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, this.dropdownSelectedValue, this.filterDropdownIdentifier);

    };



    $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, _.debounce(function (event, itemName) {
        if ((this.advancedFilterType+'_'+this.criterionTemplate.name) === itemName) {
            let tempItemList = _.filter(this.itemsList, function (item) {
                    return item.selected;
                }),
                values = _.map(tempItemList, 'value');
            values = _.join(values, '::');
            if (this.criterionTemplate.value !== values) {
                this.criterionTemplate.value = values;
                $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
            }
        }
    }.bind(this)), 500);

    this.handleSelect = function (select) {
        this.select = select;
        let selectedItems = null;
        if (!_.isNil(select.selected)) {
            // don't reset the selected value if it's a warning
            if (_.isNil(select.selected.value) && this.isSpecialMessageDisplayed) {
                select.selected = null;
                return;
            }
            selectedItems = select.selected.value;
        }

        this.criterionTemplate.value = selectedItems;

        $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, this.dropdownSelectedValue, this.filterDropdownIdentifier);
        $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
    };

    this.getComponentId = function (filterCriterionTemplate) {
        return this.advancedFilterType + 'AdvancedFilterType ' + filterCriterionTemplate.variableName;
    };

    this.handleRemove = function () {
        advancedFilterModel.unselectFilterCriterion(this.advancedFilterType, this.criterionTemplate.id);
        $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
    };

    $scope.$on(coreConstant.event.FILTER_CLEARED, function (event, criterionTemplateId) {
        if (criterionTemplateId === this.criterionTemplate.id) {
            this.criterionTemplate.value = null;
            this.updateDropdownSelectedValue();
        }
    }.bind(this));

    $scope.$on('$destroy', function () {
        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    });
};

angular.module('umCore')
    .controller('selectFilterController', SelectFilterController);
